import sponser1 from "../../assets/client-1.png";
import sponser2 from "../../assets/client-2.png";
import sponser3 from "../../assets/client-3.png";
import sponser4 from "../../assets/client-4.png";
import sponser5 from "../../assets/client-5.png";
import sponser6 from "../../assets/client-6.png";
export const paragraphs = [
  "Ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  "Duis aute irure dolor in reprehenderit in voluptate velit.",
  "Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate trideta storacalaperda mastiro dolore eu fugiat nulla pariatur.",
];
export const cards = [
  
  // {
  //   title: "Artificial Intelligence (AI)",
  //   text: " We offers AI services to help businesses improve their operations, automate processes, and enhance customer experiences.....",
  //   number: "01",
  // },
  // {
  //   title: "3D modeling & rigging",
  //   text: "We provides 3D modeling, rendering, and rigging services to various industries, including architecture, engineering, film and animation, and video game development......",
  //   number: "02",
  // },
  // {
  //   title: "Mobile Application",
  //   text: "We provides mobile application development services with UI/UX for both Android and iOS platforms......",
  //   number: "03",
  // },
  
];

export const sponsors = [
  sponser1,
  sponser2,
  sponser3,
  sponser4,
  sponser5,
  sponser6,
];
